var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "54ufa",
    d: "M1242.368 7982.3a6.42 6.42 0 0 1-1.537 1.583 8.705 8.705 0 0 1-.351 2.86 8.897 8.897 0 0 1-1.095 2.358 9.267 9.267 0 0 1-1.75 1.997c-.677.579-1.493 1.04-2.448 1.385a8.958 8.958 0 0 1-3.064.517 8.509 8.509 0 0 1-4.706-1.376c.222.026.468.038.74.038a6 6 0 0 0 3.804-1.309 2.987 2.987 0 0 1-1.783-.612 2.997 2.997 0 0 1-1.082-1.513c.21.032.402.048.58.048.271 0 .54-.035.806-.105a3.015 3.015 0 0 1-1.76-1.057 2.96 2.96 0 0 1-.698-1.95v-.038c.43.24.892.37 1.386.389a3.06 3.06 0 0 1-.997-1.09 2.986 2.986 0 0 1-.37-1.462c0-.556.14-1.072.418-1.546a8.686 8.686 0 0 0 2.794 2.262 8.538 8.538 0 0 0 3.524.944 3.403 3.403 0 0 1-.076-.702c0-.847.299-1.57.897-2.167a2.953 2.953 0 0 1 2.167-.897c.886 0 1.632.323 2.24.968a6.008 6.008 0 0 0 1.944-.74 2.975 2.975 0 0 1-1.347 1.688 6.105 6.105 0 0 0 1.764-.474z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1228 -7981)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#54ufa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.be259fd1bef975447dd83a606617cea1.svg";
export { ForwardRef as ReactComponent };